//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '4.3.3'.
//
package com.wintermar.inspection.graphql.adapter

import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.AnyAdapter
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.json.JsonReader
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.missingField
import com.wintermar.inspection.graphql.ApproveInspectionMutation
import kotlin.Any
import kotlin.String
import kotlin.collections.List

public object ApproveInspectionMutation_ResponseAdapter {
  public object Data : Adapter<ApproveInspectionMutation.Data> {
    public val RESPONSE_NAMES: List<String> = listOf("approveInspection")

    override fun fromJson(reader: JsonReader, customScalarAdapters: CustomScalarAdapters): ApproveInspectionMutation.Data {
      var _approveInspection: Any? = null

      while (true) {
        when (reader.selectName(RESPONSE_NAMES)) {
          0 -> _approveInspection = AnyAdapter.fromJson(reader, customScalarAdapters)
          else -> break
        }
      }

      return ApproveInspectionMutation.Data(
        approveInspection = _approveInspection ?: missingField(reader, "approveInspection")
      )
    }

    override fun toJson(
      writer: JsonWriter,
      customScalarAdapters: CustomScalarAdapters,
      `value`: ApproveInspectionMutation.Data,
    ) {
      writer.name("approveInspection")
      AnyAdapter.toJson(writer, customScalarAdapters, value.approveInspection)
    }
  }
}
